import styles from './styles.module.css';
import React from 'react';
import { Button, CloseButton, Icon } from '../index';
import { Icons } from '../Icon/Icon';

interface DeletePopupProps {
    onCancel: React.MouseEventHandler<HTMLButtonElement>;
    onDelete: React.MouseEventHandler<HTMLButtonElement>;
    isPermanent?: boolean;
    deleteTitle?: string;
    deleteInfo?: string;
}

const DeletePopup = ({ onCancel, onDelete, isPermanent = true, deleteTitle, deleteInfo }: DeletePopupProps) => {
    return (
        <div className={styles.container}>
            <div className={styles.popup}>
                <div className={styles.header}>
                    <span className={'h1'}>
                        {deleteTitle || isPermanent
                            ? 'Are you sure you want to delete this overview?'
                            : 'Move to Deleted items?'}
                    </span>

                    <div className={styles.close}>
                        <Button onClick={onCancel} grey={true} before={<Icon icon={Icons.closeRounded} />}>
                            Close
                        </Button>
                    </div>
                </div>
                <div className={styles.body}>
                    <p>
                        {deleteInfo || isPermanent
                            ? "This item will be deleted immediately. You can't undo this action."
                            : 'This item can be restored later.'}
                    </p>
                    <div className={styles.bts}>
                        <Button grey={true} onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button onClick={onDelete}>Delete</Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeletePopup;
